import initialState from './initialState';
import actionType from './actionTypes';

const gcContextReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_GC_CONTEXT_SUCCESS:
            return {
                ...state,
                gcContext: action.payload,
                isLoading: false,
            };
        case actionType.SAVE_GC_CONTEXT_SUCCESS:
            return {
                ...state,
                gcContext: action.payload,
                isSaving: false,
            };
        case actionType.CLEAN_GC_CONTEXT:
            return { ...initialState };
        default:
            return state;
    }
};

export default gcContextReducer;
